import { combineReducers } from 'redux';
import appReducer from './appSlice';
import * as authReducer from 'modules/auth/reducer';
import * as modalReducer from 'modules/modal/reducer';
import * as employeeReducer from 'modules/employee/reducer';
import * as vehicleReducer from 'modules/vehicle/reducer';
import * as routeReducer from 'modules/route/reducer';
import * as reportReducer from 'modules/report/reducer';
import * as companyReducer from 'modules/company/reducer';
import * as permissionReducer from 'modules/permission/reducer';
import * as monthlyTicketReducer from 'modules/monthly-ticket/reducer';
import * as customerReducer from 'modules/customer/reducer';
import * as governanceReducer from 'modules/governance/reducer';
import * as trackingReducer from 'modules/tracking/reducer';
import * as notifyReducer from 'modules/notification/reducer';
import * as transportOrdersReducer from 'modules/transport-orders/reducer';
import * as executiveReducer from 'modules/executive/reducer';
import * as promotionReducer from 'modules/promotion/reducer';
import * as businessPlanReducer from 'modules/business-plan/reducer';

const rootReducer = combineReducers({
    appReducer,
    ...authReducer,
    ...modalReducer,
    ...employeeReducer,
    ...vehicleReducer,
    ...routeReducer,
    ...reportReducer,
    ...companyReducer,
    ...permissionReducer,
    ...monthlyTicketReducer,
    ...customerReducer,
    ...governanceReducer,
    ...trackingReducer,
    ...notifyReducer,
    ...transportOrdersReducer,
    ...executiveReducer,
    ...promotionReducer,
    ...businessPlanReducer,
});

export default rootReducer;
